'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const clsx = require('clsx');
const React = require('react');
const reactAriaComponents = require('react-aria-components');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_6vpf2_1";
const styles = {
	root: root
};

const SelectionChipList = ({ "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, children, className, defaultSelectedKeys, items, onSelectionChange, selectedKeys, selectionMode, size = "small", style, variant = "primary" }) => {
  const contextValue = React.useMemo(() => ({
    selectionMode: selectionMode !== null && selectionMode !== void 0 ? selectionMode : void 0,
    size,
    variant
  }), [selectionMode, size, variant]);
  return React__default.default.createElement(
    reactAriaComponents.TagGroupContext.Provider,
    { value: contextValue },
    React__default.default.createElement(
      reactAriaComponents.TagGroup,
      { "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "data-zds": true, defaultSelectedKeys, onSelectionChange, selectedKeys, selectionMode },
      React__default.default.createElement(reactAriaComponents.TagList, { className: clsx.clsx(className, styles.root), "data-zds": true, items, style }, children)
    )
  );
};

exports.SelectionChipList = SelectionChipList;
//# sourceMappingURL=SelectionChipList.cjs.js.map
